import { ref, watch, onBeforeUnmount } from 'vue';
import useUrlParams from '@composables/use-url-params';

/**
 * @typedef { import("vue").Ref } Ref
 * @typedef { import("vue").MaybeRef } MaybeRef
 */

/**
 * Composable to manage a state that is synced with a url param.
 *
 * @param {string} paramKey key of the url param
 * @param {Object} config config object
 * @param {string} config.initialValue initial (fallback) value
 * @returns {Ref<string>} ref to the state
 */
export default function useUrlState(paramKey, { initialValue }) {
  const { params } = useUrlParams();
  const state = ref(initialValue || null);

  if (params[paramKey]) {
    state.value = decodeURIComponent(params[paramKey]);
  }

  onBeforeUnmount(() => {
    delete params[paramKey];
  });

  watch(state, state => {
    params[paramKey] = encodeURIComponent(state);
  });

  return { state };
}
